import React, { memo, useMemo } from "react";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

import { BILL_PAYMENT_CONSTANTS, IMAGES } from "./constant";
import { ButtonContainer, FlexCta, HeadingTitleContainer, DescriptionContainer } from "./styled";
import { IBillPaymentContentProps, IBillPaymentCTA } from "./types";

const BillPaymentContent = memo(
    ({ onSecondaryAction, onPrimaryAction }: IBillPaymentContentProps) => {
        const ctas: IBillPaymentCTA[] = useMemo(
            () => [
                {
                    text: BILL_PAYMENT_CONSTANTS.SECONDARY_BUTTON_TEXT,
                    buttonType: "secondary",
                    onClick: onSecondaryAction,
                },
                {
                    text: BILL_PAYMENT_CONSTANTS.PRIMARY_BUTTON_TEXT,
                    buttonType: "primary",
                    onClick: onPrimaryAction,
                },
            ],
            [onSecondaryAction, onPrimaryAction]
        );

        return (
            <>
                <Image
                    src={IMAGES.BILL_PAYMENT}
                    alt={BILL_PAYMENT_CONSTANTS.IMAGE_ALT}
                    cloudinaryHeight={BILL_PAYMENT_CONSTANTS.ICON_SIZE * 2}
                    cloudinaryWidth={BILL_PAYMENT_CONSTANTS.ICON_SIZE * 2}
                    height={String(BILL_PAYMENT_CONSTANTS.ICON_SIZE)}
                    width={String(BILL_PAYMENT_CONSTANTS.ICON_SIZE)}
                />

                <HeadingTitleContainer>
                    <Text variant="V2.heading1.neutral.bold" color="text_Highest_Emphasis">
                        {BILL_PAYMENT_CONSTANTS.TITLE}
                    </Text>
                </HeadingTitleContainer>

                <DescriptionContainer>
                    <Text variant="V2.body1.neutral.regular" color="text_Med_Emphasis">
                        {BILL_PAYMENT_CONSTANTS.DESCRIPTION}
                    </Text>
                </DescriptionContainer>

                <ButtonContainer>
                    {ctas?.map((cta) => (
                        <FlexCta key={cta?.text}>
                            <SuperButton
                                buttonType={cta.buttonType || "primary"}
                                buttonSize="large"
                                onClick={cta.onClick}
                            >
                                {cta.text}
                            </SuperButton>
                        </FlexCta>
                    ))}
                </ButtonContainer>
            </>
        );
    }
);

BillPaymentContent.displayName = "BillPaymentContent";

export default BillPaymentContent;
